import { Box, CircularProgress, styled } from '@material-ui/core'
import { CoinLeaf, CoinLeafFill } from 'components/icons'
import { Coin } from 'components/icons/coin'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { formatNumber } from 'utils/numbers'

const Container = styled('section')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  padding: theme.spacing(3, 0),
  gap: theme.spacing(2),
  borderRadius: theme.spacing(2),
  background: 'linear-gradient(0deg, rgb(255, 255, 255) 30%, #ffda94)',
  boxShadow: '0px 4px 15.2px 0px #0000001A',
  marginTop: '-50px',
}))

const CoinWrapper = styled('div')(({ theme }) => ({
  padding: '5px',
  background: theme.palette.common.white,
  borderRadius: theme.spacing(1),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}))

const BalanceText = styled('span')(({ theme }) => ({
  fontSize: '20px',
}))

const BalanceValue = styled('span')(({ theme }) => ({
  fontSize: '35px',
  color: '#FFA600',
}))

export const Balance = ({ balance = 0, isLoading }) => {
  const { t, i18n } = useTranslation()

  return (
    <Container>
      <CoinWrapper>
        <CoinLeafFill width={35} height={'auto'} fill='#f7b63b' />
      </CoinWrapper>

      <BalanceText>{t('creditosDeBiodiversidade.saldoTotalLBC')}</BalanceText>
      {isLoading ? (
        <CircularProgress size={25} />
      ) : (
        <BalanceValue>{formatNumber(balance, i18n.language)}</BalanceValue>
      )}
    </Container>
  )
}
